/** Faits confirmés par BT-027. Rien n’est complété au-delà de ces lignes. */

export const HUNT_IDS = ["mem_luc", "mem_eric", "mem_marcel", "mem_pierre", "mem_steve", "mem_dan"];

export const PERMIT_URL = "https://www.quebec.ca/tourisme-loisirs-sport/activites-sportives-et-de-plein-air/mon-dossier-chasse-peche";

export const MEET_POINT = "Station-service près de l’aéroport de Gatineau";

export const CONVOYS = [
  {
    id: "luc",
    title: "Convoi Luc",
    lines: [
      "Luc conduit son camion avec long trailer.",
      "Luc et Steve voyagent ensemble.",
      "Le trailer transporte le 6 roues de Steve.",
      "Autre 4 roues : à confirmer.",
    ],
  },
  {
    id: "eric",
    title: "Convoi Éric",
    lines: [
      "Éric conduit son véhicule avec trailer.",
      "Marcel voyage avec Éric.",
      "Side-by-side d’Éric.",
      "Un 4 roues.",
    ],
  },
];

export const ROAD_STOP = "Dîner et essence : décidé ensemble pendant le trajet.";
export const TERRAIN_COUNT = "4 véhicules terrain prévus. Noms et propriétaires : à confirmer.";

export const COMMS = [
  "Éric apporte des walkie-talkies haute portée.",
  "Luc apporte des walkie-talkies.",
  "Toute personne qui en possède un devrait l’apporter.",
];

export const CAMERAS = "2 caméras de chasse déjà installées.";
export const READERS = "Marcel apporte le laptop, l’iPad et les adaptateurs pour lire les cartes mémoire.";

export const RECOVERY = [
  "Steve : Sawzall",
  "Luc : lames",
  "Éric et Luc : carburant pour les équipements",
  "Équipement de récupération : à confirmer au chargement.",
];

export const BUTCHER = {
  name: "Boucherie Allard",
  who: "Steve",
  note: "Seulement si un orignal est récolté. Steve prend contact. Pas une tâche de chaque matin.",
};

export const ROOMS = [
  { id: "c1", title: "Chambre 1", who: "Luc + Steve" },
  { id: "c2", title: "Chambre 2", who: "Pierre Bertrand" },
  { id: "c3", title: "Chambre 3", who: "Marcel" },
  { id: "c4", title: "Chambre du bout", who: "Dan + Éric" },
];

export const ESSENTIALS = [
  ["vest", "Dossard fluorescent — exigé selon les règles du Québec"],
  ["idcard", "Pièce d’identité"],
  ["bedding", "Literie / sac de couchage"],
  ["towel", "Serviette"],
  ["clothes", "Vêtements de chasse"],
  ["rain", "Vêtements de pluie"],
  ["boots", "Bottes"],
  ["lamp", "Lampe / frontale"],
  ["chargers", "Chargeurs"],
  ["phone", "Téléphone"],
  ["meds", "Médicaments personnels"],
  ["pain", "Aspirine / analgésique"],
  ["hygiene", "Brosse à dents / hygiène"],
  ["permit", "Permis"],
  ["rifle", "Carabine / équipement personnel"],
  ["cooler", "Glacière si nécessaire"],
];

export const WATER = [
  "Éric : bouteilles d’eau potable",
  "Luc : 2 bidons d’eau de ville",
  "Usage : cuisson et besoins du chalet.",
];

export const DRINKS = "Chacun apporte ses boissons, alcoolisées ou non.";
export const TOILET_PAPER = "Papier de toilette : Éric.";
export const DISHES = "Celui qui apporte le souper le prépare. Les autres font la vaisselle à tour de rôle.";
export const LUNCH = "Chacun prépare son lunch le matin. Éric a fait la majorité des achats communs : sandwichs, granolas, collations, gâteries.";
export const BIG_BREAKFAST = "Un gros déjeuner possible : Éric achète les œufs et le bacon. Pour une mauvaise météo, une chasse terminée, ou une journée plus relaxe.";
export const OTHER_MORNINGS = "Les autres matins : toast et ce qui est déjà au chalet.";
export const FREEZER = "Pense à sortir la nourriture du congélateur pour qu’elle soit dégelée au retour.";

export const SEPAQ_MAIL_NOTE = "Chantal a transféré le courriel d’inscription Sépaq les 16 et 17 septembre. Ce lien n’est pas dans l’export Messenger.";
export const PERMIT_NOTE = "Lien du permis, envoyé par Marcel le 17 septembre. Zone 27.";

export const NO_NEW_POINTS = "Aucun nouveau point publié. La version 1 reste la carte du départ.";
